import React from 'react';
import { Nav } from 'react-bootstrap';
import { AiOutlineHome } from 'react-icons/ai';
import { RiBrush3Line, RiStore2Line } from 'react-icons/ri';
import { BsPeople } from 'react-icons/bs';
import { CgProfile } from 'react-icons/cg';

import './bottomnav.css';

export const BottomNav = () => {
    return (
        <>
            {/* <Tabs
                    id="uncontrolled-tab-example"
                    className="mb-2 pt-2 preview-category flex-nowrap overflow-scroll justify-content-center"
                    // onClick={handleTabChange}
                    defaultValue={'home'}
                >
                {
                    ['Home', 'Themes', 'Community', 'Store', 'Profile'].map((_ele, i) => (
                            <Tab key={i} eventKey={_ele} title={_ele}>
                                
                            </Tab>
                        ))
                    }
                </Tabs> */}

            <Nav variant="pills" fill className='bg-dark rounded mt -1'>
                <Nav.Item>
                    <Nav.Link eventKey="link-1" className='active'>
                        <AiOutlineHome size={"24px"} color={"white"} />
                    </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link eventKey="link-2">
                        <RiBrush3Line size={"24px"} color={"white"} />
                    </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link eventKey="link-3">
                        <BsPeople size={"24px"} color={"white"} />
                    </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link eventKey="link-4">
                        <RiStore2Line size={"24px"} color={"white"} />
                    </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link eventKey="link-5">
                        <CgProfile size={"24px"} color={"white"} />
                    </Nav.Link>
                </Nav.Item>
            </Nav>

            {/* <ul className='navbar-nav'>
                    <li>
                        <AiOutlineHome />
                    </li>
                    <li>
                    <RiBrush3Line />
                    </li>
                    <li>
                    <BsPeople />
                    </li>
                    <li>
                    <RiStore2Line />
                    </li>
                    <li>
                    <CgProfile />
                    </li>
                </ul> */}
        </>
    )
}

export default BottomNav